import React, { useState } from 'react';


const SignIn = () => {
  const [form, setForm] = useState({
    email: '',
    password: '',
  });
  const [rememberMe, setRememberMe] = useState(false);
  const [message, setMessage] = useState('');
  const supportEmail =  process.env.REACT_APP_SUPPORT_EMAIL || 'tryjaca@gmail.com';
  const serviceDomain = process.env.REACT_APP_SERVICE_DOMAIN;
 
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      username: form.email,
      password: form.password,
      rememberMe,
    };
    try {
      const res = await fetch(`${serviceDomain}/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      if (res.ok) {
        if (data.user) {
          // Check if account is disabled
          if (data.user.is_disabled) {
            setMessage('This account has been disabled. Please contact support at ' + supportEmail + ' for assistance. ');
            return;
          }
          
          setMessage('Sign in successful!');
          if (data.token) {
            localStorage.setItem('token', data.token);
          }
          localStorage.setItem('user', JSON.stringify(data.user));
          // Redirect based on user_type and orientation status
          if (data.user.user_type === 3) {
            if (data.user.is_orientation_complete === 0) {
              window.location.href = `/vendorsignupfull?user_id=${data.user.id}`;
            } else if (data.user.is_background_checked === 0) {
              window.location.href = `/vendorsignupverification?user_id=${data.user.id}`;
            } else {
              window.location.href = `/vendordashboard?user_id=${data.user.id}`;
            }
          } 
          else if(data.user.user_type === 2){
             window.location.href = '/admin';
          }
          else {
            window.location.href = '/customerdashboard';
          }
        }
      } else {
        setMessage(data.message || 'Sign in failed.');
      }
    } catch (err) {
      setMessage('Sign in failed.');
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <form style={styles.form} onSubmit={handleSubmit}>
        <h2 style={styles.title}>Sign In to Jaca</h2>
        <input
          style={styles.input}
          type="email"
          name="email"
          placeholder="Email"
          value={form.email}
          onChange={handleChange}
          required
        />
        <input
          style={styles.input}
          type="password"
          name="password"
          placeholder="Password"
          value={form.password}
          onChange={handleChange}
          required
        />
        {/* <div style={styles.rememberContainer}>
          <label style={styles.rememberLabel}>
            <input
              type="checkbox"
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
              style={styles.checkbox}
            />
            Remember me
          </label>
        </div> */}
        <button style={styles.button} type="submit">Sign In</button>
        {message && (
          <div style={{ marginTop: '16px', color: '#4078c0', textAlign: 'center' }}>
            {/* Show "Verify your email before signing in" in red */}
            {message.includes('Verify') ? (
              <span style={{ color: 'red', fontWeight: 'bold' }}>
                {message}
              </span>
            ) : (
              message
            )}
            {message.includes('Verify') && (
              <div style={{ marginTop: '12px' }}>
                <button
                  style={{
                    background: 'none',
                    border: 'none',
                    color: '#4078c0',
                    textDecoration: 'underline',
                    cursor: 'pointer',
                    fontSize: '1rem',
                    marginTop: '4px'
                  }}
                  type="button"
                  onClick={async () => {
                    try {
                      const res = await fetch(`${process.env.REACT_APP_SERVICE_DOMAIN}/resend-verification`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ email: form.email }),
                      });
                      const data = await res.json();
                      setMessage(data.message || 'Verification email resent.');
                      // Clear username/password fields after sending verification email
                      setForm({ email: '', password: '' });
                    } catch {
                      setMessage('Could not resend verification email.');
                      setForm({ email: '', password: '' });
                    }
                  }}
                >
                  Resend verification email
                </button>
              </div>
            )}
          </div>
        )}
        {/* <div style={{ textAlign: 'center', margin: '24px 0 8px 0', fontWeight: 'bold', color: '#888' }}>
          Or
        </div> */}
        {/* Remove social sign-in buttons */}
        {/* <div style={styles.socialContainer}>
          <button type="button" style={{ ...styles.socialBtn, background: '#4267B2', color: '#fff' }}>
            <i className="fab fa-facebook-f" style={styles.icon}></i> Continue with Facebook
          </button>
          <button type="button" style={{ ...styles.socialBtn, background: '#fff', color: '#444', border: '1px solid #ddd' }}>
            <i className="fab fa-google" style={styles.icon}></i> Continue with Google
          </button>
          <button type="button" style={{ ...styles.socialBtn, background: '#000', color: '#fff' }}>
            <i className="fab fa-apple" style={styles.icon}></i> Continue with Apple
          </button>
        </div> */}
        <div style={{ fontSize: '0.85rem', color: '#555', marginTop: '18px', textAlign: 'center' }}>
          By signing in or signing up, I agree to the Jaca Terms of Service and Privacy Statement, consent to receive marketing email and messages from Jaca and its affiliates.
          <div style={{ marginTop: '12px' }}>
            <a href="/forgot-password" style={{ color: '#4078c0', textDecoration: 'underline' }}>
              Forgot password?
            </a>
          </div>
          <div style={{ marginTop: '18px' }}>
            Don't have a Jaca account?{' '}
            <a href="/signup" style={{ color: '#4078c0', textDecoration: 'underline' }}>
              Sign up now.
            </a>
          </div>
        </div>
       
      </form>
    </div>
  );
};

const styles = {
  form: {
    background: '#fff',
    padding: '48px',
    borderRadius: '12px',
    boxShadow: '0 2px 16px rgba(0,0,0,0.12)',
    display: 'flex',
    flexDirection: 'column',
    width: '400px', // Increased width
    minHeight: '480px', // Increased height
  },
  title: {
    marginBottom: '24px',
    textAlign: 'center',
    color: '#2f3640',
  },
  input: {
    marginBottom: '16px',
    padding: '10px',
    borderRadius: '4px',
    border: '1px solid #dcdde1',
    fontSize: '16px',
  },
  button: {
    padding: '12px',
    borderRadius: '4px',
    border: 'none',
    background: '#4078c0',
    color: '#fff',
    fontWeight: 'bold',
    fontSize: '16px',
    cursor: 'pointer',
  },
  rememberContainer: {
    marginBottom: '16px',
    display: 'flex',
    alignItems: 'center',
  },
  rememberLabel: {
    display: 'flex',
    alignItems: 'center',
    color: '#555',
    fontSize: '14px',
    cursor: 'pointer',
  },
  checkbox: {
    marginRight: '8px',
    transform: 'scale(1.1)',
  },
  socialContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    margin: '24px 0 0 0',
  },
   socialBtn: {
    padding: '12px',
    borderRadius: '4px',
    fontWeight: 'bold',
    fontSize: '16px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
  },
  icon: {
    fontSize: '20px',
    marginRight: '8px',
  },
};

export default SignIn;